import { useAuthState, useQuery } from '@based/sdk/react'
import { useBasedEndpoints } from '../providers/Endpoints/index.js'

type User = {
  id: number
  name: string
  email: string
  role?: string
  status?: string
  picture?: string
  passkeys?: {
    id: number
  }[]
  passkeysReminder?: number
}

export const useUser = (): User => {
  const endpoints = useBasedEndpoints()
  const { token } = useAuthState()

  const { data = {} } = useQuery(
    token ? endpoints.user : '',
    { token },
    { persistent: true },
  )

  return data || {}
}
